export const identity = <T>(t: T) => {
    return t;
};
